export class Login {
  username: string;
  password: string;
  userid: string;
}




export class UserRegistration {
    active: boolean = false;
    email: string = '';
    phone: string = '';
    firstName: string = '';
    lastName: string = '';
    enabled: boolean = false;
    gpsEnabled:boolean = false;
    webEnabled: boolean = false;
    password: string = '';
    imageUrl: string = '';
    authSource: string = '';
    userid: string = '';

}